const AUTO_ROTATE_INTERVAL_MS = 5000;

/**
 * A custom element that manages announcement carousel in cart drawer.
 */
class CartAnnouncementCarousel extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.slidesContainer = this.querySelector('.cart-announcement-banner__slides');
    this.slides = this.querySelectorAll('.cart-announcement-banner__slide');
    this.totalSlides = this.slides.length;
    this.autoRotateInterval = null;
  }

  connectedCallback() {
    this.startAutoRotate();
  }

  disconnectedCallback() {
    this.stopAutoRotate();
  }

  previous() {
    this.currentIndex = (this.currentIndex - 1 + this.totalSlides) % this.totalSlides;
    this.updateSlidePosition();
    this.resetAutoRotate();
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.totalSlides;
    this.updateSlidePosition();
    this.resetAutoRotate();
  }

  updateSlidePosition() {
    if (this.slidesContainer) {
      this.slidesContainer.style.transform = `translateX(-${this.currentIndex * 100}%)`;
    }
  }

  startAutoRotate() {
    if (this.totalSlides > 1) {
      this.autoRotateInterval = setInterval(() => {
        this.next();
      }, AUTO_ROTATE_INTERVAL_MS);
    }
  }

  stopAutoRotate() {
    if (this.autoRotateInterval) {
      clearInterval(this.autoRotateInterval);
      this.autoRotateInterval = null;
    }
  }

  resetAutoRotate() {
    this.stopAutoRotate();
    this.startAutoRotate();
  }
}

if (!customElements.get('cart-announcement-carousel')) {
  customElements.define('cart-announcement-carousel', CartAnnouncementCarousel);
}
